import * as React from 'react'
import Modal from '@src/components/common/dialog'
import * as styles from './about.us.styl'

export interface DialogProps {
  open: boolean
  onClose: () => void
}

const Dialog: React.FC<DialogProps> = (
  props: React.PropsWithChildren<DialogProps>
) => (
  <Modal title={'About Us'} open={props.open} onClose={props.onClose}>
    <AboutUsView />
  </Modal>
)

export interface EditorGuardrailProps {}

export const AboutUsView: React.FC<EditorGuardrailProps> = () => (
  <div className={styles.content}>
    <p>Copyright © 2020 SailPoint Technologies, Inc. All Rights Reserved.</p>
    <p>
      All logos, text, content, including underlying HTML code, designs, and
      graphics used and/or depicted on these written materials or in this
      Internet website are protected under United States and international
      copyright and trademark laws and treaties, and may not be used or
      reproduced without the prior express written permission of SailPoint
      Technologies, Inc.
    </p>
    <p>
      “SailPoint,” “SailPoint & Design,” “SailPoint Technologies & Design,”
      “AccessIQ,” “Identity Cube,” “Identity IQ,” “IdentityAI,” “IdentityNow,”
      “Managing the Business of Identity,” and “SecurityIQ” are registered
      trademarks of SailPoint Technologies, Inc. None of the foregoing marks may
      be used without the prior express written permission of SailPoint
      Technologies, Inc.
    </p>
    <p>
      Patents:{' '}
      <a
        title={'SailPoint Patents'}
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.sailpoint.com/patents"
      >
        https://www.sailpoint.com/patents
      </a>
    </p>
  </div>
)

export default Dialog
